/*--------------------
* Ventures Section
----------------------*/
// livePreview: false renders a static cover instead of an iframe —
// use it for sites that are down or can't be embedded.
const VENTURES = [
  {
    name: "Hit My Macros",
    tag: "iOS App",
    url: "https://www.hitmymacros.app/landing",
    display: "hitmymacros.app",
    text: "A no-nonsense nutrition tracker that makes hitting your daily protein, carb, and fat targets dead simple.",
    livePreview: true,
  },
  {
    name: "Telephant",
    tag: "iOS App",
    url: "https://telephantapp.com",
    display: "telephantapp.com",
    text: "An elephant never forgets — and neither does this app. Currently making waves on iOS.",
    livePreview: true,
  },
  {
    name: "Marketing Dwarf",
    tag: "SaaS",
    url: "https://www.marketingdwarf.com",
    display: "marketingdwarf.com",
    text: "A design and development studio crafting stylish, modern websites, web services, and online stores for businesses of every size.",
    livePreview: false,
    logo: "img/brands/marketingdwarf-logo.png",
  },
  {
    name: "GPT-Corrugated",
    tag: "AI / SaaS",
    url: "https://www.gpt-corrugated.com",
    display: "gpt-corrugated.com",
    text: "AI tooling purpose-built for the corrugated packaging industry, bringing modern language models to an old-school trade.",
    livePreview: false,
  },
];

function SitePreview({ venture }) {
  return (
    <div className="browser-frame">
      <div className="browser-bar">
        <span className="dot bg-[#ff5f57]"></span>
        <span className="dot bg-[#febc2e]"></span>
        <span className="dot bg-[#28c840]"></span>
        <span className="url">{venture.display}</span>
      </div>
      {venture.livePreview ? (
        <div className="iframe-holder">
          <iframe
            src={venture.url}
            title={venture.name}
            loading="lazy"
          ></iframe>
        </div>
      ) : (
        <div className="iframe-holder flex items-center justify-center bg-gradient-to-b from-night-700 to-night-900">
          <div className="absolute inset-0 bg-grid" aria-hidden="true"></div>
          <div className="relative flex flex-col items-center gap-4">
            {venture.logo && (
              <img
                src={venture.logo}
                alt={venture.name}
                className="h-[64px] w-auto"
              />
            )}
            <span className="font-display text-[26px] md:text-[32px] font-[600] text-mist-100">
              {venture.name}
            </span>
            <span className="font-mono text-[12px] tracking-[2px] text-mist-500 uppercase">
              {venture.tag}
            </span>
          </div>
        </div>
      )}
      <a
        className="visit-pill"
        href={venture.url}
        target="_blank"
        rel="noreferrer"
      >
        Visit site →
      </a>
      <a
        className="absolute inset-0 z-[1]"
        href={venture.url}
        target="_blank"
        rel="noreferrer"
      >
        <span className="sr-only">Visit {venture.name}</span>
      </a>
    </div>
  );
}

export default function Work() {
  return (
    <section id="ventures" className="section bg-night-950">
      <div className="container">
        <div className="section-heading text-center">
          <p className="eyebrow">03 — The portfolio</p>
          <h2>Ventures in the wild</h2>
        </div>

        <div className="flex flex-col gap-16 lg:gap-24">
          {VENTURES.map((venture, i) => (
            <div
              key={venture.name}
              className="grid lg:grid-cols-12 grid-cols-1 gap-8 lg:gap-12 items-center"
            >
              <div
                className={`lg:col-span-7 ${
                  i % 2 === 1 ? "lg:order-last" : ""
                }`}
              >
                <SitePreview venture={venture} />
              </div>
              <div className="lg:col-span-5">
                <span className="inline-block font-mono text-[11px] uppercase tracking-[2px] text-ember-400 border border-ember-400/30 rounded-full px-4 py-[6px] mb-5">
                  {venture.tag}
                </span>
                <h3 className="text-[28px] md:text-[36px] font-[600] leading-[1.15] mb-4">
                  {venture.name}
                </h3>
                <p className="text-[16px] md:text-[17px] leading-relaxed mb-6">
                  {venture.text}
                </p>
                <a
                  className="font-mono text-[13px] uppercase tracking-[2px] text-mist-300 hover:text-ember-400 transition-colors duration-200"
                  href={venture.url}
                  target="_blank"
                  rel="noreferrer"
                >
                  {venture.display} ↗
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
